window.displayError = function displayError($div, messages) {
	var html = '<div class="alert alert-danger fade show">';
	html += '<a href="javascript:undefined;" class="close" data-dismiss="alert">&times;</a>';
	for (let key in messages) {
		html += messages[key]+"<br>";
	}
	html += '</div>';

	$div.html(html).slideDown();
}

// {"label":["The label field is required."],"name":["The name field is required."]}
// {"Error":["This is the error message"]}


window.displayToast = function displayToast(messages) {
	for (let key in messages) {
		if(key == "trace") {
				continue;
		}
		if (typeof(messages[key]) == "object") {
			var text = '';
			for (let line in messages[key]) {
				text += messages[key][line]+'<br>';
			}
		} else {
				text = messages[key];
		}
		if (text) {
			iziToast.error({
				title: key,
				message: text
			});
		}
	}
}

// For backward compatability
window.displayErrorGritter = function displayErrorGritter(messages) {
	displayToast(messages);
}

window.displayGritter = window.displayToast;
